
import Cookies from "js-cookie"
import { translate } from "@/plugins/i18n"
import {
  reSetLogin,
  praseToken,
  getDomain,
  getLoginStatus,
  setCookies,
  redirectToLoginPage,
  openPop
} from "@/utils/utils"
import { logOut } from "@/api/auth"
import { getValidCouponList } from "@/api/coupon"
import storage from "@/utils/storage"
import YuuPoint from "@/components/YuuPoint"
import { LINK_YUU_TYPE } from "@/constants/auth"

const routes = [
  "/cards",
  "/coupons",
  "/address",
  "/order_list",
  "/order_details",
  "/payment_result",
  "/pending_payment",
  "/cart",
  "/checkout",
  "/receipt",
  "/notification_center"
]

export default {
  name: "Top",
  components: {
    YuuPoint
  },
  data() {
    return {
      lang: "",
      langList: [
        {
          name: "EN",
          lang: "en_US"
        },
        {
          name: "繁中",
          lang: "zh_HK"
        }
      ],
      accountList: [
        {
          type: "myProfile",
          alias: "profile"
        },
        {
          type: "myCards",
          alias: "cards"
        },
        {
          type: "myCoupons",
          alias: "coupons"
        },
        {
          type: "myAddresses",
          alias: "address"
        },
        {
          type: "myOrders",
          alias: "order_list"
        },
        {
          type: "notification",
          alias: "notification"
        },
        {
          type: "logout"
        }
      ],
      langListShow: false,
      isOnline: false,
      accountListShow: false,
      popContent: {},
      accountInfo: {},
      memberPointsAvailable: 0,
      memberPointEquivalent: 0,
      couponCount: 0,
      cardCount: 0,
      showLogin: false,
      showLoginAndregister: false,
      showLogined: false,
      customerShow: false
    }
  },

  computed: {
    storeLocatorLink() {
      return this.$t("footer.storeLocatorLink")
    }
  },
  created() {},
  async mounted() {
    this.lang = this.$i18n.locale
    await this.$store.dispatch("getLoginInfo")
    const { isOnline } = getLoginStatus()
    this.isOnline = isOnline
    this.showLogined = !!isOnline
    this.showLoginAndregister = !isOnline
    if (this.isOnline) {
      const accountInfo = storage.get("accountInfo", { useBase64: true }) || {}
      this.accountInfo = accountInfo
      if (this.accountInfo && this.accountInfo.pointVo) {
        this.memberPointsAvailable = this.accountInfo.pointVo.memberPointsAvailable
        this.memberPointEquivalent = this.accountInfo.pointVo.memberPointEquivalent
      }
      this.getCouponCount()
      this.getCardCount()
    }
    if (process.env.VUE_APP_LOGIN_SHOW == "true") {
      this.showLogin = true
    }
  },

  methods: {
    async getCouponCount() {
      const params = {}
      const { data: res } = await getValidCouponList({ param: JSON.stringify(params) })
      this.couponCount = res.count || 0
    },
    async getCardCount() {
      try {
        const data = await this.$sdk?.getBindCardList()
        this.cardCount = data ? data.length : 0
      } catch (error) {
        // console.log(error)
      }
    },
    handleChangeLanguage(item) {
      const lang = this.$i18n.locale
      if (item.lang === lang) {
        this.langListShow = false
        return
      }
      let href = window.location.href

      if (lang === "zh_HK") {
        setCookies("superweb-locale", "en_US")
        this.$i18n.locale = "en_US"
        this.langListShow = false
        if (href.includes("/zh-hant")) {
          href = href.replace("/zh-hant", "/en")
          // this.$navigation.push(href)
          window.location.href = href
        } else {
          window.location.reload()
        }
      } else {
        setCookies("superweb-locale", "zh_HK")
        this.$i18n.locale = "zh_HK"
        this.langListShow = false
        if (href.includes("/en")) {
          href = href.replace("/en", "/zh-hant")
          // this.$navigation.push(href)
          window.location.href = href
        } else {
          window.location.reload()
        }
      }
    },
    openAuth() {
      if (window.location.pathname.includes("/auth/login")) {
        window.location.reload()
      } else {
        redirectToLoginPage()
      }
    },
    handleLangHover() {
      this.langListShow = true
    },
    handleLangOut() {
      this.langListShow = false
    },
    handleAccountHover() {
      this.accountListShow = true
    },
    handleAccountOut() {
      this.accountListShow = false
    },
    handleCustomerHover() {
      this.customerShow = true
    },
    handleCustomerOut() {
      this.customerShow = false
    },
    async logOutFun() {
      const token = Cookies.get("token") || false
      const parseData = token ? praseToken(token) : null
      const url = window.location.href
      let redirect = false

      const _this = this

      const res = await logOut({
        token,
        yuuId: parseData?.loyaltyCardId || parseData?.LoyaltyCardId,
        domain: getDomain()
      }).catch(resE => {
        this.$message({
          type: "info",
          message: translate("common.logoutfailed") + "：" + resE
        })
      })
      console.log("logout:", res)
      if (res.data == 0) {
        reSetLogin()
        this.$message({
          type: "info",
          message: translate("common.logoutSuccess")
        })
        routes.forEach(item => {
          if (url.includes(item)) {
            redirect = true
          }
        })
        setTimeout(() => {
          if (redirect) {
            window.location.href = `${_this.MAIN_ORIGIN_HOME}`
          } else {
            window.location.reload()
          }
        }, 1000)
      }
    },
    handleLogOut() {
      this.popContent = {
        title: translate("common.logOutTips"),
        message: translate("common.logOutMsg"),
        cancelText: translate("common.no"),
        confirmText: translate("common.yes")
      }
      this.$refs.messageBox.open()
    },
    goItem(item) {
      if (item.type === "logout") {
        this.handleLogOut()
      } else {
        if (item.type === "accountSetting") {
          const url = item[`url_${this.lang}`]
          if (url) {
            window.open(url)
          }
        } else {
          this.$navigation.push({
            path: "/" + item.alias
          })
        }
        this.handleAccountOut()
      }
    },
    handleJumpWellComeCenter() {
      return this.$t("common.customerCareLink")
    },
    goFeedback() {
      const link = this.$t("common.feedbackLink")
      window.open(link)
    },
    handleClickContinue() {
      const phoneWithAreaCode = this.accountInfo.areaCode + " " + this.accountInfo.phone
      openPop("", phoneWithAreaCode, LINK_YUU_TYPE.BIND_YUU)
    }
  }
}
